import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d6a3583"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "actions" }


export default /*#__PURE__*/_defineComponent({
  props: {
    shoppingCartLabel: null
  },
  emits: ["navigate"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "action action--cart",
      to: "/cart",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(__props.shoppingCartLabel), 1)
      ]),
      _: 1
    })
  ]))
}
}

})